// extracted by mini-css-extract-plugin
export var fullGrid = "_3s-3";
export var pdpPreviewContainer = "_3s-1";
export var previewContainer = "_3s-0";
export var togglePreviewContainer = "_3s-2";